import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAccountMarketingMaterialFlyerPrintTemplateComponent } from './helpers';
import { isHumanJoinCode } from '../../../../../../../../util/join-code';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    logo_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
};

const AccountMarketingMaterialFlyerPrintTemplate = ({
  account,
  albumFolder,
}) => {
  const Template = getAccountMarketingMaterialFlyerPrintTemplateComponent({
    albumFolder,
  });
  const logoUrl = account?.logo_image?.url;

  const logoClasses = classNames({
    'marketing-material-flyer-account-logo': true,
    // Should match SB No Join Code When condition
    'sb-no-join-code-logo':
      !isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.search_subscription_credits_joins_enabled,
  });

  return (
    <Fragment>
      {logoUrl && (
        <span className={logoClasses}>
          {logoUrl && <img src={logoUrl} alt="" />}
        </span>
      )}

      <Template albumFolder={albumFolder} account={account} />
    </Fragment>
  );
};

AccountMarketingMaterialFlyerPrintTemplate.propTypes = propTypes;

export default AccountMarketingMaterialFlyerPrintTemplate;
